module.exports = __webpack_public_path__ + "static/media/animat-diamond-color.c63f6841.gif";